import { CalendarMonth } from "@mui/icons-material";
import { Box, Stack } from "@mui/material";
import { TimeIcon } from "@mui/x-date-pickers";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import NonWorkingDatesList from "./components/NonWorkingDatesList";
import { useParams } from "react-router-dom";
import {
  EDIT_WORKING_DAYS,
  GET_WORKING_DAYS,
} from "../../../../../enums/ApiPaths";
import { useFetch } from "../../../../../hooks/Fetching";
import { workingDays } from "./enums/workingDays";
import WorkingDaysDisplay from "./components/WorkingDaysDisplay";
import { FormProvider, useForm } from "react-hook-form";
import MyLoadingButton from "../../../../../components/buttons/MyLoadingButton";
import { MANGAE_WORKING_HOURS } from "../../../../../enums/PermissionTitles";
import { prepareDataForSubmittion } from "./utils/WorkingDaysFunctions";
import { WORKING_HOURS_TABLE } from "../../../../../enums/QueryKeys";
import Skeletons from "../../../../../components/loader/Skeletons";
import ErrorFullScreenMessage from "../../../../../components/fullScreenMessage/ErrorFullScreenMessage";
import usePutWorkingHours from "./hooks/usePutWorkingHours";
import ChipTabs from "../../../../../components/ChipsTabs";
import PageContentWrapper from "../../../../../components/wrappers/PageContentWrapper";
import { useRedirectIfNotOwnClinic } from "../../../../../hooks/useRedirectIfNotOwnClinic";

export default function WorkingHoursPage() {
  const { t } = useTranslation();
  const { id: clinicId } = useParams();
  useRedirectIfNotOwnClinic(clinicId);
  const fetch = useFetch(GET_WORKING_DAYS, clinicId, WORKING_HOURS_TABLE);
  const methods = useForm();
  const path = EDIT_WORKING_DAYS + clinicId;
  const submittion = usePutWorkingHours(path, WORKING_HOURS_TABLE);

  function submitData() {
    const workingDaysArray = methods.getValues();
    const data = prepareDataForSubmittion(workingDaysArray);
    submittion.submitCallback(data);
  }

  const hours =
    fetch?.data?.length > 0 && fetch.data.some((item) => item.day !== null)
      ? fetch.data.filter((item) => item.day !== null)
      : workingDays;

  const withoutDay = fetch?.data?.filter((item) => item.day === null);

  if (fetch?.isLoading || fetch?.data == null || fetch?.data == undefined) {
    return (
      <PageContentWrapper>
        <Skeletons numOfSkeletons={7} height={50} grid={false} />
      </PageContentWrapper>
    );
  } else if (fetch?.error && !fetch?.isLoading) {
    return (
      <PageContentWrapper>
        <ErrorFullScreenMessage />
      </PageContentWrapper>
    );
  }

  const icons = [<TimeIcon />, <CalendarMonth />];
  const labels = ["WorkingHours", "NonWorkingDates"];
  const content = [
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(submitData)}>
        <Stack spacing={2}>
          <Box>
            <MyLoadingButton
              isLoading={submittion.loading}
              message={t("Save")}
              permissions={[MANGAE_WORKING_HOURS]}
              testId="clinic.working-hours.save-button"
            />
          </Box>
          {hours?.map((workingDay) => (
            <WorkingDaysDisplay workingDay={workingDay} key={workingDay?.day} />
          ))}
        </Stack>
      </form>
    </FormProvider>,
    <NonWorkingDatesList
      fetch={fetch}
      nonWorkingDates={withoutDay}
      key={"non-working-hours-list"}
    />,
  ];

  return (
    <PageContentWrapper>
      <ChipTabs
        lsKey={"WORKING_HOURS_LS_KEY"}
        icons={icons}
        tabLabels={labels}
        tabTestIds={["clinic.working-hours.hours-tab", "clinic.working-hours.non-working-tab"]}
        tabContent={content}
        wrapperMaxWidth="90vw"
      />
    </PageContentWrapper>
  );
}
